<template>
  <div :id="graphid" :style="setStyle">
  </div>
</template>

<script>

export default {
  props: ['styling', 'graphid'],
  computed: {
    setStyle () {
      return {
        width: this.styling.width + 'px',
        height: this.styling.height + 'px',
        fill: this.styling.background
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#root-graph {
  z-index: 3;
}
</style>
